export const configKeys = {
  GEMINI_USER_NAME: process.env.NEXT_PUBLIC_GEMINI_USER_NAME as string,
  GEMINI_PASSWORD: process.env.NEXT_PUBLIC_GEMINI_PASSWORD as string,
  GEMINI_BASE_URL_V1: process.env.NEXT_PUBLIC_GEMINI_BASE_URL_V1 as string,
  GEMINI_BASE_URL_V2: process.env.NEXT_PUBLIC_GEMINI_BASE_URL_V2 as string,
  GEMINI_BASE_URL_V3: process.env.NEXT_PUBLIC_GEMINI_BASE_URL_V3 as string,
  GEMINI_BASE_URL_WC_V2: process.env.NEXT_PUBLIC_GEMINI_BASE_URL_WC_V2 as string,
  GEMINI_NEW_BASE_URL: process.env.NEXT_PUBLIC_GEMINI_NEW_BASE_URL as string,
  GEMINI_API_KEY: process.env.NEXT_PUBLIC_GEMINI_API_KEY as string,
  GEMINI_CLIENT_KEY: process.env.NEXT_PUBLIC_GEMINI_CLIENT_KEY as string,
};
